// extracted by mini-css-extract-plugin
export default {"likesContainer":"likesCounter_likesContainer__ZMuqr","likesCount":"likesCounter_likesCount__c0AHE","likeBtn":"likesCounter_likeBtn__i0iEq"};